/**
 * @generated SignedSource<<b8c2e67523dc10283dfa09673529179e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type SignatureModal_getTicketQuery$variables = {
  id: string;
};
export type SignatureModal_getTicketQuery$data = {
  readonly getTicket: {
    readonly id: string;
    readonly uuid: string | null;
  };
};
export type SignatureModal_getTicketQuery = {
  response: SignatureModal_getTicketQuery$data;
  variables: SignatureModal_getTicketQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TicketObjectType",
    "kind": "LinkedField",
    "name": "getTicket",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uuid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignatureModal_getTicketQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SignatureModal_getTicketQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0c02d80ae97a4ff7f35f784d0e0940d0",
    "id": null,
    "metadata": {},
    "name": "SignatureModal_getTicketQuery",
    "operationKind": "query",
    "text": "query SignatureModal_getTicketQuery(\n  $id: String!\n) {\n  getTicket(id: $id) {\n    id\n    uuid\n  }\n}\n"
  }
};
})();

(node as any).hash = "f98a668a141306e25428f2acab813882";

export default node;
